import React from "react";
import { Star, Quote, ExternalLink } from "lucide-react";

const GOOGLE_URL =
  "https://www.google.com/search?sa=X&sca_esv=0444657f1031709e&hl=en&authuser=0&biw=390&bih=699&sxsrf=ANbL-n5AF-t3QSGrTSethgx8G9d2e7KcEQ%3A1781379695575&kgmid=%2Fg%2F11zfq70sdd&q=Faithfully%20Clean%20Pressure%20Washing&shem=epsd1%2Crimspwouoe&shndl=30&source=sh%2Fx%2Floc%2Fact%2Fm4%2F3";

const REVIEWS = [
  {
    name: "Maria G.",
    city: "Kissimmee, FL",
    body: "Our driveway looked brand new! On time, friendly, and the price was right. Will absolutely use them again.",
  },
  {
    name: "Pastor James W.",
    city: "Orlando, FL",
    body: "They washed our church building inside a tight window. Honest, faith-driven, and excellent work. Highly recommend.",
  },
  {
    name: "Tasha R.",
    city: "Winter Garden, FL",
    body: "Roof streaks completely gone after the soft wash. Communication from start to finish was perfect.",
  },
];

function GoogleG({ className = "w-5 h-5" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.4 6.5 29.5 4.5 24 4.5 13.2 4.5 4.5 13.2 4.5 24S13.2 43.5 24 43.5 43.5 34.8 43.5 24c0-1.2-.1-2.3-.4-3.5z"/>
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 16 18.9 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.4 6.5 29.5 4.5 24 4.5 16.3 4.5 9.7 8.9 6.3 14.7z"/>
      <path fill="#4CAF50" d="M24 43.5c5.3 0 10.1-2 13.7-5.3l-6.3-5.3c-2 1.4-4.6 2.3-7.4 2.3-5.3 0-9.7-3.4-11.3-8.1L6 31.4C9.3 38.6 16.1 43.5 24 43.5z"/>
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.3 5.3C41.7 35.4 43.5 30 43.5 24c0-1.2-.1-2.3 .1-3.5z"/>
    </svg>
  );
}

export default function Testimonials() {
  return (
    <section className="py-20 md:py-28 bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <div className="font-script text-3xl text-[var(--fc-orange)]">Kind words</div>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold text-[var(--fc-blue-dark)] mt-1">
            What our neighbors say.
          </h2>
          <a
            href={GOOGLE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-5 inline-flex items-center gap-2 bg-white border border-blue-100 hover:border-[var(--fc-blue)] hover:-translate-y-0.5 transition-all rounded-full pl-3 pr-5 h-12 shadow-sm font-bold text-slate-700"
            data-testid="google-find-us"
          >
            <span className="w-7 h-7 rounded-full bg-white border border-slate-200 grid place-items-center">
              <GoogleG />
            </span>
            <span>Find us on Google &amp; leave a review</span>
            <ExternalLink className="w-4 h-4 text-slate-400" />
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {REVIEWS.map((r) => (
            <div
              key={r.name}
              className="relative bg-[var(--fc-surface)] border border-blue-100 rounded-3xl p-7 shadow-sm hover:-translate-y-1 transition-transform"
              data-testid={`testimonial-${r.name.toLowerCase().split(' ')[0]}`}
            >
              <Quote className="absolute top-5 right-5 w-8 h-8 text-[var(--fc-blue)]/30" />
              <div className="flex gap-1 text-[var(--fc-orange)]">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-current" />
                ))}
              </div>
              <p className="mt-4 text-slate-800 leading-relaxed">&ldquo;{r.body}&rdquo;</p>
              <div className="mt-5">
                <div className="font-heading font-bold text-[var(--fc-blue-dark)]">{r.name}</div>
                <div className="text-sm text-slate-500">{r.city}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-3xl bg-white border border-blue-100 p-8 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10 shadow-lg shadow-blue-900/5">
          <div className="flex-1">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-white border border-slate-200 grid place-items-center shadow-sm">
                <GoogleG className="w-6 h-6" />
              </div>
              <div>
                <div className="font-heading text-xl font-bold text-[var(--fc-blue-dark)]">
                  Loved your wash? Help us spread the word.
                </div>
                <div className="text-slate-600 text-sm">
                  Your honest review on Google means the world to a small, faith‑based business.
                </div>
              </div>
            </div>
          </div>
          <a
            href={GOOGLE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center btn-orange font-heading font-extrabold uppercase tracking-wider px-7 h-13 py-3 rounded-full"
            data-testid="google-review-cta"
          >
            Leave a Google Review
          </a>
        </div>
      </div>
    </section>
  );
}
